/**
 * Extracts the hostname from a URL string.
 * Returns undefined if the URL is invalid.
 */
export const extractUrlHostname = (sourceUrl: string): string | undefined => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};
